<div class="container mt-3">
  <form [formGroup]="mainForm">
    <div class="grid">
      <div class="field col-12 md:col-4">
        <p-floatlabel>
          <p-select class="w-100" [options]="genderService.genders" formControlName="title" optionLabel="title"
                      inputId="title" optionValue="id" [showClear]="true"></p-select>
          <label for="title">Anrede</label>
        </p-floatlabel>

        @if (mainForm.get('title')?.invalid && mainForm.get('title')?.dirty) {
          <span class='p-error'>
            Anrede ist erforderlich.
          </span>
        }
      </div>
      <div class="md:col-8"></div>

      <div class="field col-12 md:col-6">
        <p-floatlabel>
          <input class="w-100" id="first_name" type="text" formControlName="first_name" pInputText/>
          <label for="first_name">Vorname</label>
        </p-floatlabel>

        @if (mainForm.get('first_name')?.errors?.['required'] && mainForm.get('first_name')?.dirty) {
          <span class='p-error'
          >
            Vorname ist erforderlich.
          </span>
        }
      </div>
      <div class="field col-12 md:col-6">
        <p-floatlabel>
          <input id="last_name" class="w-100" type="text" formControlName="last_name" pInputText/>
          <label for="last_name">Nachname</label>
        </p-floatlabel>

        @if (mainForm.get('last_name')?.errors?.['required'] && mainForm.get('last_name')?.dirty) {
          <span class='p-error'>
            Nachname ist erforderlich.
          </span>
        }

      </div>

      <div class="field col-12 md:col-8">
        <p-floatlabel>
          <p-autoComplete [suggestions]="streetSuggestions" (completeMethod)="searchStreets($event)" [minLength]="1"
                          (onSelect)="onStreetSelected($event.value)" [dropdown]="true" [multiple]="false"
                          [forceSelection]="false" class="w-100"
                          formControlName="street"></p-autoComplete>
          <label for="street">Straße</label>
        </p-floatlabel>

        @if (mainForm.get('street')?.errors?.['required'] && mainForm.get('street')?.dirty) {
          <span class='p-error'>
            Straße ist erforderlich.
          </span>
        }
      </div>
      <div class="field col-12 md:col-4">
        <p-floatlabel>
          <input id="house_number" class="w-100" type="text" formControlName="house_number" pInputText/>
          <label for="house_number">Nr.</label>
        </p-floatlabel>

        @if (mainForm.get('house_number')?.errors?.['required'] && mainForm.get('house_number')?.dirty) {
          <span class='p-error'>
            Nr. ist erforderlich.
          </span>
        }

        @if (mainForm.get('house_number')?.errors?.['pattern'] && mainForm.get('house_number')?.dirty) {
          <span class='p-error'>
            Nr. ist falsch formatiert.
          </span>
        }
      </div>
      <div class="field col-12">
        <p-floatlabel>
          <input id="address_addition" class="w-100" type="text" formControlName="address_addition" pInputText/>
          <label for="address_addition">Adresszusatz</label>
        </p-floatlabel>
      </div>

      <div class="field col-4">
        <p-floatlabel>
          <input id="zip" class="w-100" type="text" formControlName="zip" pInputText/>
          <label for="zip">PLZ</label>
        </p-floatlabel>

        @if (mainForm.get('zip')?.errors?.['required'] && mainForm.get('zip')?.dirty) {
          <span class='p-error'>
            PLZ ist erforderlich.
          </span>
        }

        @if (mainForm.get('zip')?.errors?.['pattern'] && mainForm.get('zip')?.dirty) {
          <span class='p-error'>
            PLZ ist falsch formatiert.
          </span>
        }
      </div>

      <div class="field col-8">
        <p-floatlabel>
          <input id="city" class="w-100" type="text" formControlName="city" pInputText/>
          <label for="city">Stadt</label>
        </p-floatlabel>

        @if (mainForm.get('city')?.errors?.['required'] && mainForm.get('city')?.dirty) {
          <span class='p-error'>
            Stadt ist erforderlich.
          </span>
        }
      </div>

      <div class="field col-12">
        <p-floatlabel>
          <p-select inputId="location" class="w-100" [options]="locationService.locations" optionValue="id"
                      formControlName="future_location" optionLabel="city"></p-select>
          <label [for]="'location'">Künftiger Ausgabeort</label>
        </p-floatlabel>
        @if (mainForm.get('future_location')?.invalid && mainForm.get('future_location')?.dirty) {
          <span class='p-error'>
            Künftiger Ausgabeort ist erforderlich.
          </span>
        }
      </div>

      <div class="field col-12">
        <p-floatlabel>
          <input id="phone" class="w-100" type="text" formControlName="phone" pInputText/>
          <label for="phone">Telefon</label>
        </p-floatlabel>

        @if (mainForm.get('phone')?.errors?.['pattern'] && mainForm.get('phone')?.dirty) {
          <span class='p-error'>
            Telefonnr. ist falsch formatiert.
          </span>
        }
      </div>

      <div class="field col-12">
        <p-floatlabel>
          <input id="mobile" class="w-100" type="text" formControlName="mobile" pInputText/>
          <label for="mobile">Handy</label>
        </p-floatlabel>

        @if (mainForm.get('mobile')?.errors?.['pattern'] && mainForm.get('mobile')?.dirty) {
          <span class='p-error'>
            Handy-Nr. ist falsch formatiert.
          </span>
        }
      </div>

      <div class="field col-12">
        <p-floatlabel>
          <input id="mail" class="w-100" type="text" formControlName="mail" pInputText/>
          <label for="mail">Mail</label>
        </p-floatlabel>

        @if (mainForm.get('mail')?.errors?.['email'] && mainForm.get('mail')?.dirty) {
          <span class='p-error'>
            E-Mail ist ungültig.
          </span>
        }
      </div>

      <div class="field col-12">
        <p-floatlabel variant="in">
          <textarea id="comment" class="w-100" type="text" formControlName="comment" pTextarea></textarea>
          <label for="comment">Bemerkung</label>
        </p-floatlabel>
      </div>


      <div class="col-12">
        <h2>Betreuer / Dolmetscher</h2>
      </div>
      <div class="col-12">
        <div class="flex justify-content-start">
          <p-button class="flex-grow-0" label="HINZUFÜGEN" (click)="addSupervisor()"></p-button>
        </div>
      </div>

      <div class="w-100">
        <div class="p-fluid grid mt-3" formArrayName="supervisors">
        @for (supervisor of supervisors.controls; track supervisor; let i = $index) {
          <ng-container [formGroupName]="i">
            <div class="field">
              <input type="hidden" formControlName="id">
            </div>
            <div class="field col-12 md:col-5">
              <p-floatlabel>
                <input class="w-100" id="name" type="text" formControlName="name" pInputText/>
                <label for="name">Name</label>
              </p-floatlabel>
            </div>
            <div class="field col-12 md:col-5">
              <p-floatlabel>
                <input id="contact" class="w-100" type="text" formControlName="contact" pInputText/>
                <label for="contact">Kontakt</label>
              </p-floatlabel>
            </div>
            <div class="col-12 md:col-2">
              <p-button (click)="removeSupervisor(i)" icon="pi pi-times" [rounded]="true" severity="danger" [outlined]="true"></p-button>
            </div>
          </ng-container>
        }
      </div>
      </div>

    </div>

  </form>
</div>
